import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import pending from './pending'
import env from '../config/env'
import Router from '../router'

Vue.use(Vuex)

const { baseURL } = env
const { normalURL } = env

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    pending,
  },
  strict: process.env.DEV,
  state: {
    user: {
      id: null,
      name: '',
      remote_check: false,
      photo: '',
      photo_url: '',
    },
    closeMirror: {},
    authenticated: false,
    notifications: 0,
    token: '',
    api: baseURL,
    url: normalURL,
    breadcrumbs: [{ name: 'Home', route: '/' }],
    has_signature: false, // valor padrão para evitar erro
  },
  getters: {
    has_signature: state => state.has_signature,
    getCloseMirror: state => state.closeMirror,
    token: state => state.token,
    authenticated: state => {
      if (state.token == null || state.token == 'null') {
        return false
      }

      return state.authenticated
    },
    logo: state => state.logo,
    user: state => state.user,
    api: state => state.api,
    breadcrumbs: state => state.breadcrumbs,
  },
  mutations: {
    auth(state, token) {
      if (token != null && token != undefined) {
        state.authenticated = true
        state.token = token

        localStorage.clear()
        localStorage.setItem('token', token)

        axios.defaults.headers.common.authorization = `Bearer ${localStorage.getItem('token')}`
        this.commit('profileUpdate')
        this.commit('getConfiguration')
      }
    },
    updateNotifications(state, data) {
      state.notifications = Number(state.notifications) + 1
    },
    close_mirror(state, data) {
      state.closeMirror = data
    },
    getConfiguration(state) {
      axios.get(`${state.api}configurations`)
        .then(response => {
          const config = response?.data?.data?.[0]
          state.has_signature = config?.has_signature ?? false
        })
        .catch(() => {
          state.has_signature = false
        })
    },
    profileUpdate(state) {
      axios.post(`${state.api}me`, {
        token: state.token,
      })
        .then(response => {
          state.user.id = response.data.id
          state.user.name = response.data.name
          state.user.email = response.data.email
          state.user.is_admin = response.data.is_admin
          state.user.remote_check = response.data.remote_check
          state.user.photo = `${state.url}/user/image/${response.data.id}`
          state.user.photo_url = response.data.photo_url

          localStorage.setItem('accept_terms', response.data.accept_terms)
          localStorage.setItem('is_admin', response.data.is_admin)

          axios.defaults.headers.common.authorization = `Bearer ${localStorage.getItem('token')}`
        })
        .catch(error => {
          localStorage.clear()

          Router.push('/login')
        })
    },
    updateBreadCrumbs(state, newRoute) {
      if (state.breadcrumbs.length > 1) {
        state.breadcrumbs.pop()
      }
      state.breadcrumbs.push(newRoute)
      // state.breadcrumbs = newRoute;
    },
  },
  actions: {
    initialize(context) {
      const token = localStorage.getItem('token')
      context.commit('auth', token)
    },
  },
})
